import { css, Theme } from '@emotion/react'
import { buttonClasses, formHelperTextClasses } from '@mui/material'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(1, 2, 1)};
`

export const header = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing(2)};

  margin: ${theme.spacing(2, 0)};
`

export const title = css`
  font-weight: 700;
`

export const actionButtons = (theme: Theme) => css`
  display: flex;
  gap: ${theme.spacing(1)};
  flex-wrap: wrap;
`

export const deleteButton = (theme: Theme) => css`
  &.${buttonClasses.root} {
    color: ${theme.colors.red};

    :active {
      color: ${theme.colors.red};
    }

    :disabled {
      opacity: 0.8;

      color: ${theme.colors.red};
    }
  }

  svg {
    height: 22px;
    width: 22px;
  }
`

export const hr = (theme: Theme) => css`
  height: 1px;

  background-color: ${theme.colors.backgroundOne};
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};

  margin: 0 auto;
  max-width: 754px;
`

export const subtitle = css`
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
`

export const columns = (theme: Theme) => css`
  display: flex;
  gap: ${theme.spacing(2)};
`

export const column = (theme: Theme) => css`
  width: 100%;
  border-radius: 20px;
  background: ${theme.colors.backgroundThree};
  padding: ${theme.spacing(2)};

  .${formHelperTextClasses.root} {
    color: ${theme.colors.red};
  }
`

export const field = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const fieldArray = (theme: Theme) => css`
  .${formHelperTextClasses.root} {
    color: ${theme.colors.red};
  }
`
